import { render, staticRenderFns } from "./ScreenshotManagement.vue?vue&type=template&id=1600f2d5&scoped=true"
import script from "./ScreenshotManagement.vue?vue&type=script&lang=js"
export * from "./ScreenshotManagement.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotManagement.vue?vue&type=style&index=0&id=1600f2d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600f2d5",
  null
  
)

export default component.exports